module.exports = __webpack_public_path__ + "img/tripteev.4c723c7e.svg";